export interface PaymentRefund {
    id: string
    amount: number
    lineItemIds: string[]
    lineItemAmounts: Record<string, number>
    dateCreated: Date
}

export class Payment {
    constructor(
        public id: string,
        public paymentIntentId: string | null,
        public dateCreated: Date,
        public datePaid: Date | null,
        public amount: number | null = null,
        public refunds: PaymentRefund[] = [],
        public capturedTransactionId: string | null = null
    ) {}

    get canRefundOnline(): boolean {
        return !!this.datePaid && !!(this.capturedTransactionId ?? this.paymentIntentId)
    }

    get amountRefunded(): number {
        return this.refunds.reduce((total, refund) => total + refund.amount, 0)
    }

    get balance(): number {
        return this.datePaid ? (this.amount ?? 0) - this.amountRefunded : 0
    }

    get status(): string {
        if (!this.datePaid) {
            return 'Unpaid'
        }
        if (this.amountRefunded === 0) {
            return 'Paid'
        }
        return this.balance > 0 ? 'Partially refunded' : 'Refunded'
    }

    amountRefundedForLine(lineItemId: string): number {
        return this.refunds.reduce((total, refund) => total + (refund.lineItemAmounts[lineItemId] ?? 0), 0)
    }
}
